import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SvgRoombooking1(
  { title, titleId, ...props }: Props,
  svgRef?: Ref<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      viewBox="0 0 144 144"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        className="st0"
        d="M84,84v-31.88c0-1.95,1.84-3.38,3.74-2.93,16.41,3.9,29.07,17.42,31.71,34.28.29,1.84-1.1,3.53-2.97,3.53h-29.48c-1.66,0-3-1.34-3-3ZM75,84V15c0-1.66-1.34-3-3-3h-36c-1.66,0-3,1.34-3,3v33c0,21.54,17.46,39,39,39h0c1.66,0,3-1.34,3-3ZM33,99v30c0,1.66,1.34,3,3,3h42c19.85,0,36.44-13.79,40.82-32.3.45-1.89-1-3.7-2.94-3.7H36c-1.66,0-3,1.34-3,3Z"
      />
    </svg>
  );
}

export default forwardRef(SvgRoombooking1);
